import { Skeleton } from 'primereact/skeleton'
import './DialogScanCode.scss'

export function ScanConfirmPanelSkeleton() {
  return (
    <div className="scan-qr-confirm scan-qr-confirm--page">
      <div className="scan-qr-confirm__panel scan-qr-confirm__panel--page scan-qr-confirm__panel--loading border-round-xl p-3 w-full">
        <div className="scan-qr-confirm__panel-scroll">
          <div className="flex flex-column align-items-center text-center w-full">
            <div className="flex align-items-center justify-content-center gap-2 w-full">
              <Skeleton shape="circle" size="2rem" />
              <Skeleton width="12rem" height="1.5rem" className="max-w-full" />
            </div>
            <Skeleton className="mt-2 w-full" width="100%" height="0.875rem" />
          </div>

          <div className="scan-qr-confirm__card border-round-xl p-4 mt-3 w-full">
            <div className="mb-0">
              <Skeleton width="3rem" height="0.8125rem" className="mb-1" />
              <Skeleton width="100%" height="1.375rem" />
            </div>

            <div className="scan-qr-confirm__card-divider" />

            <div className="scan-qr-confirm__meta-row flex gap-4 w-full">
              <div className="flex-1 min-w-0">
                <Skeleton width="4.5rem" height="0.8125rem" className="mb-1" />
                <Skeleton width="100%" height="1rem" />
              </div>
              <div className="flex-1 min-w-0">
                <Skeleton width="5.5rem" height="0.8125rem" className="mb-1" />
                <Skeleton width="100%" height="1rem" />
              </div>
            </div>

            <div className="scan-qr-confirm__card-divider" />

            <div className="mb-3">
              <Skeleton width="2.5rem" height="0.8125rem" className="mb-1" />
              <Skeleton width="100%" height="1rem" />
            </div>
            <div>
              <Skeleton width="5.5rem" height="0.8125rem" className="mb-1" />
              <Skeleton width="100%" height="1rem" />
            </div>
          </div>
        </div>

        <div className="scan-qr-confirm__panel-actions flex flex-column gap-3">
          <Skeleton className="w-full" width="100%" height="3.1rem" />
          <Skeleton className="w-full" width="100%" height="3.1rem" />
        </div>
      </div>
    </div>
  )
}
